import { useEffect, useState } from "react";
import {
  Route,
  BrowserRouter,
  Routes,
  Navigate,
  useNavigate,
} from "react-router-dom";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import DashBoard from "./components/dashboard/dashboard";
import { getUser } from "./components/config/user";
import DrawerAppBar from "./components/appbar/drawerappbar";
import Homepage from "./components/homepage/homepage";
import AddCasesDashboard from "./components/dashboard/cases/addcases/AddCasesDashboard";
import InternalUserManagement from "./components/internalUserManagement/InternalUserManagement";
import InternalUsers from "./components/internalUserManagement/InternalUsers";
import Sidebarorg from "./components/appbar/Sidebar";
import Subscriptionplan from "./components/Subscription/Subscriptionplan";
import Forgotpassword from "./components/forgotpassword/Forgotpassword";
import Teanmemberdashboard from "./components/teammemberdashboard/Teammemberdashboard";
import EditCasesDashboard from "./components/dashboard/cases/editCases/EditCasesDashboard";
import InitiateAdmission from "./components/hospitaldashboard/InitiateAdmission/InitiateAdmission";
import MapDocumentCaseList from "./components/dashboard/cases/mapdocuments/MapDocumentCaseList";
import SubscriptionBox from "./components/Subscription/Subscriptionplan";
import AddSubadmin from "./components/dashboard/Admin/Subadmin/AddSubadmin";
import EditSubadmin from "./components/dashboard/Admin/Subadmin/EditSubadmin";
import Subadminlist from "./components/dashboard/Admin/Subadmin/Subadminlist";
import ManageRpa from "./components/managerpa/ManageRpa";
import ManageRpaLogs from "./components/managerpa/ManageRpaLogs";
import Hospitaldashboard from "./components/hospitaldashboard/Hospitaldashboard";
import DirectUploadDocUi from "./components/dashboard/cases/casedetails/DirectUploadDocUi";
import Hospitallist from "./components/hospitallist/Hospitallist";
import HospitalListBeta from "./components/hospitallist/HospitalListBeta";
import AddHospital from "./components/addhospital/Addhospital";
import Managequery from "./components/managequery/Managequery";
import ApproveHospital from "./components/approvehospital/ApproveHospital";
import Report from "./components/report/Report";
import CcReportDocumentTypeWise from "./components/report/CcReportDocumentTypeWise";
import NotificationsStructure from "./components/notificationsStructure/NotificationsStructure";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AddDoctor from "./components/adddoctor/AddDoctor";
import InterCase from "./components/intercase/InterCase";
import ManageProcedure from "./components/dashboard/cases/manageProcedure/ManageProcedure";
import NotificationSound from "./components/assets/notificationSound.wav";
import { AuthServices } from "./components/services/AuthServices";

import { useSelector, useDispatch } from "react-redux";
import {
  requestForToken,
  onMessageListener,
} from "./components/services/Firebase";
import {
  updateCaseId,
  setUserAssignedStages,
  fetchUserAssignedCases,
  setNewCaseAddRequest,
} from "./components/redux/caseDetailsSlice";
import {
  updateNewOtpMessage,
  updateMessageId,
} from "./components/redux/notificationSlice";
import ManualNotification from "./components/dashboard/manualNotification/ManualNotification";
import EditDocuments from "./components/editDocuments/EditDocuments";
import ActiveCasesDashboardV2 from "./components/dashboard/cases/activeCasesDashboardV2";
import ActiveCasesDashboardBeta from "./components/dashboard/cases/activeCasesDashboardBeta";
import ClaimCases from "./components/dashboard/cases/claimCases/ClaimCases";
import MyAssignedCases from "./components/dashboard/cases/myAssignedCases/MyAssignedCases";
import AllCaseRecording from "./components/AllCaseRecording/AllCaseRecording";
import ProcessedQueryCases from "./components/dashboard/cases/processedQueryCases/ProcessedQueryCases";
import ManageApplication from "./components/managerpa/ManageApplication";
import TmsOtpList from "./components/tmsOTP/TmsOtpList";
import CcDocumentComent from "./components/ccDocumentComment/CcDocumentComent";
import CcDocumentComentWithKey from "./components/ccDocumentComment/CcDocumentComponentWithKey";
import SurveyDetails from "./components/survey/SurveyDetails";
import ECTDiagnosisSearch from "./components/ICD/DiagnosisSearch";
import TmsOtpLogsList from "./components/tmsOTP/TmsOtpLogsList";
import RpaErrorLogs from "./components/rpaErrorLogs/RpaErrorLogs";
import RpaQueryRequestLog from "./components/rpaQueryRequestLog/RpaQueryRequestLog";
import GetTmsUserVersionsList from "./components/tmsOTP/GetTmsUserVersionsList";
import TmsLoginDetails from "./components/managerpa/TmsLoginDetails";
import ManageInvoice from "./components/manageInvoice/ManageInvoice";
import ReferenceDocDownload from "./components/dashboard/cases/referenceDocDownload/ReferenceDocDownload";
//Landing page
import LandingPage from "./components/landingPage/LandingPage";
//Hospital and HSA Persona
import {
  fetchNotificationCount,
  fetchCommentCount,
  fetchNewCaseNotificationCount,
} from "./components/redux/notificationSlice";
import BlurScreen from "../src/components/assets/blur_screen.png";
import Header from "./components/hospitalPersona/header/Header";
import HospitalSidebar from "./components/hospitalPersona/hospitalSidebar/HospitalSidebar";
import CaseStatus from "./components/hospitalPersona/caseStatus/CaseStatus";
import CaseDetailsHospitalPersona from "./components/hospitalPersona/caseDetails/CaseDetailsHospitalPersona";
import NotificationHospitalPersona from "./components/hospitalPersona/notification/NotificationHospitalPersona";
import HospitalPersonaSubAdmin from "./components/hospitalPersona/subAdmin/HospitalPersonaSubAdmin";
import SurveyForm from "./components/survey/SurveyForm";
import DeactivateAccountForm from "./components/survey/DeactivateAccountForm";
import DocumentComments from "./components/documentComment/DocumentComments";
import CommentNotificationHospitalPersona from "./components/hospitalPersona/commentNotification/CommentNotificationHospitalPersona";
import { handleApiErrorResponses } from "./components/utils/ApisErrorHandling";
import ManageSurveyQuestions from "./components/survey/ManageSurveyQuestions";
import SurveyQuestionsReport from "./components/survey/SurveyQuestionsReport";
import AllCaseStagesInfo from "./components/caseStageSetup/AllCaseStagesInfo";
import CaseStageTimeColorIfo from "./components/caseStageSetup/CaseStageTimeColorIfo";
import UpdatedFeatures from "./components/dashboard/updatedFeatures/UpdatedFeatures";
import { InterUserMangementServices } from "./components/services/InternalUserMangementServices";
import UnderReview from "./components/underReview/UnderReview";
import {
  addRpaRunningHospitals,
  fetchRpaRunningHospitals,
  removeRpaRunningHospitals,
} from "./components/redux/hospitalDetailsSlice";
import HospitalCaseReport from "./components/hospitalPersona/hospitalCaseReport/HospitalCaseReport";
import DmLogReport from "./components/hospitalPersona/dmLogReport/DmLogReport";
import RpaReport from "./components/rpaReport/RpaReport";
import HsaReportForCC from "./components/hsaReportForCC/HsaReportForCC";
import RpaCaseWiseReport from "./components/rpaReport/RpaCaseWiseReport";
import UserInsightsCount from "./components/tmsOTP/UserInsightsCount";
import CreateInvoice from "./components/manageInvoice/CreateInvoice";
import DoctorList from "./components/dashboard/cases/addcases/DoctorList";
import ImageUploadTestPage from "./components/hospitalPersona/caseStatus/hospitalReferenceDocument/ImageUploadTestPage";
import HospitalSpecialityMapping from "./components/hospitalSpecialityMapping.jsx/HospitalSpecialityMapping";
import RequirementReport from "./components/dashboard/requirementReport/RequirementReport";
import ImprovementFeedbackForm from "./components/dashboard/cases/editCases/ImprovementFeedbackForm";
import HsaMonthlyCaseReport from "./components/hospitalPersona/hsaMonthlyCaseReport.jsx/HsaMonthlyCaseReport";
import CcMonthlyCaseReport from "./components/report/CcMonthlyCaseReport";
import ManageProcedurePage from "./components/dashboard/cases/newProcedureFlow/ManageProcedurePage";
import DefaultDocumentMappingPage from "./components/dashboard/cases/newProcedureFlow/DefaultDocumentMappingPage";

import ManageDocuments from "./components/dashboard/cases/newProcedureFlow/ManageDocuments";
import ManageScheme from "./components/dashboard/cases/newProcedureFlow/ManageScheme";
import ProcedureDocumentMapping from "./components/dashboard/cases/newProcedureFlow/ProcedureDocumentMapping";
import ProcedureMappingPage from "./components/dashboard/cases/newProcedureFlow/ProcedureMappingPage";
import ManageSpeciality from "./components/dashboard/cases/newProcedureFlow/ManageSpeciality";
import ManageDocxTypeMapping from "./components/dashboard/cases/newProcedureFlow/ManageDocxTypeMapping";
import ManageProcedureSchemeMapping from "./components/dashboard/cases/newProcedureFlow/ManageProcedureSchemeMapping";
import DefaultProcedureList from "./components/dashboard/cases/newProcedureFlow/DefaultProcedureList";
import ProcedureCostMappingEdited from "./components/dashboard/cases/newProcedureFlow/ProcedureCostMappingEdited";
import ProcedureCostMapping from "./components/dashboard/cases/newProcedureFlow/ProcedureCostMapping";
import DoctorPerformanceReport from "./components/DoctorPerformanceReport/DoctorPerformanceReport";
import DoctorCaseStageUpdate from "./components/DoctorPerformanceReport/DoctorCaseStageUpdate";
import DutPerformanceReport from "./components/DutTeamReport/DutPerformanceReport";
import DutCaseStageUpdate from "./components/DutTeamReport/DutCaseStageUpdate";
import DutPage from "./components/dashboard/cases/newProcedureFlow/DUTPage/DutPage";
import NewDutAccordion from "./components/NewDutFlow/NewDutAccordion";
import ClaimInsightsScreen from "./components/NewDutFlow/ClaimInsightsScreen";
import DutWorkspace from "./components/NewDutFlow/DutWorkspace";
import RevenueReport from "./components/hospitalPersona/hospitalSidebar/revenue/RevenueReport";
import CcCreditReport from "./components/report/CcCreditReport";
import AiConfigurations from "./components/aiConfigurations/aiConfigurations";
import AiForm from "./components/aiForm/AiForm";
import ICD10DiagnosisSearch from "./components/ICD/ICD10DiagnosisSearch";

// import ProcedureCostMapping from "./components/dashboard/cases/newProcedureFlow/ProcedureCostMapping";

const PublicRoute = ({ ...props }) => {
  let user = getUser();
  return user?.session?.token ? (
    user?.hospital?.id ? (
      <Navigate replace to="/dashboard/case-status" />
    ) : (
      <Navigate replace to="/dashboard/ActiveCases" />
    )
  ) : (
    <>
      {/* <DrawerAppBar /> */}
      <div
        style={{ backgroundImage: `url(${BlurScreen})` }}
        className={`bg-center bg-cover p-[14px] lg:p-[24px] 2xl:p-[50px]`}
      >
        <ToastContainer />
        <Header />
        <div className="flex gap-[1%] font-poppins font-normal items-start">
          <div className="w-[100%] min-h-[80vh] mt-8 xl:mt-10 2xl:mt-14">
            <Outlet />
          </div>
        </div>
      </div>
      {/* <footer /> */}
    </>
  );
};
const PublicRoute1 = ({ ...props }) => {
  return (
    <>
      <Outlet />
    </>
  );
};

const PrivateRoute1 = ({ ...props }) => {
  let user = getUser();
  const location = useLocation();

  const isDutWorkspace = location.pathname === "/dashboard/dut-work-space";

  return !user?.session?.token ? (
    <Navigate replace to="/" />
  ) : user?.hospital?.status === "INACTIVE" ? (
    <div
      style={{ backgroundImage: `url(${BlurScreen})` }}
      className={`bg-center bg-cover p-[24px] 3xl:p-[50px]`}
    >
      <ToastContainer />
      <Header />
      <div className="flex gap-[1%] font-lufga font-normal items-start mt-10">
        <div className="w-full min-h-[80vh]">
          <Outlet />
        </div>
      </div>
    </div>
  ) : user?.hospital?.id ? (
    <div
      style={{ backgroundImage: `url(${BlurScreen})` }}
      className={`bg-center bg-cover p-[24px] 3xl:p-[50px]`}
    >
      <ToastContainer />
      <Header />
      <div className="flex gap-[1%] font-lufga font-normal items-start mt-10">
        <div className="w-[14%] sticky -top-10">
          <HospitalSidebar />
        </div>
        <div className="w-[85%] min-h-[80vh]">
          <Outlet />
        </div>
      </div>
    </div>
  ) : (
    <>
      <ToastContainer />

      <DrawerAppBar
        sidebar={
          isDutWorkspace ? (
            <div className="w-0 overflow-hidden" />
          ) : (
            <Sidebarorg />
          )
        }
        loggedIn={true}
        Component={<Outlet />}
      />
    </>
  );
};

ReactGA.initialize("G-X91RS4HMK2");

function App() {
  const location = useLocation();
  const [token, setToken] = useState(null);
  const currentRole = useSelector((state) => state.currentRole.value);
  const { userChanged } = useSelector((store) => store.currentRole);
  let user = getUser();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const notificationSound = new Audio(NotificationSound);
  const updateFirebaseToken = async (fcm) => {
    const data = {
      notificationFirebaseId: fcm,
    };
    try {
      await AuthServices.updateFirebaseId(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getRequestToken = async () => {
    try {
      const token = await requestForToken();
      await updateFirebaseToken(token);
      setToken(token);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  const handleNotificationClick = (caseId) => {
    // navigate(`/Dashboard/EditCases/?caseId=${caseId}`);
  };
  const getUserAssignedStages = async () => {
    try {
      const response = await InterUserMangementServices.getUserAssignedStages();

      dispatch(
        setUserAssignedStages(response.data.assignedCommandCenterStages),
      );
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  useEffect(() => {
    const unsubscribe = onMessageListener(async (payload) => {
      if (payload.data.notificationStatus.includes("negative")) {
        toast.error(payload.data.title, {
          style: { color: payload.data.color },
          onClick: () => handleNotificationClick(payload.data.caseId),
        });
      } else if (payload.data.notificationStatus.includes("positive")) {
        toast.success(payload.data.title, {
          style: { color: payload.data.color },
          onClick: () => handleNotificationClick(payload.data.caseId),
        });
      } else {
        toast.info(payload.data.title, {
          style: { color: payload.data.color },
          onClick: () => handleNotificationClick(payload.data.caseId),
        });
      }
      notificationSound
        .play()
        .catch((err) => console.error("Audio play failed:", err));

      if (payload?.data?.caseId) {
        dispatch(updateCaseId(payload.data.caseId));
      }
      if (payload?.data?.category === "Logout") {
        window.alert(payload?.data?.body);
        const res = await AuthServices.logoutuser();
        localStorage.setItem("userDetails", {});
        localStorage.setItem("signUpUserDetails", {});
        navigate("/");
      } else if (payload?.data?.category === "Otp") {
        dispatch(updateNewOtpMessage(payload?.data?.body));
      } else if (payload?.data?.category === "Rpa") {
        if (payload?.data?.title === "RPA Start") {
          dispatch(addRpaRunningHospitals(payload?.data?.hospitalId));
        } else if (payload?.data?.title === "RPA Close") {
          dispatch(removeRpaRunningHospitals(payload?.data?.hospitalId));
        }
      } else if (
        payload?.data?.category === "New" &&
        payload?.data?.type === "CASE"
      ) {
        dispatch(setNewCaseAddRequest(false));
      }

      dispatch(updateMessageId(payload.messageId));
      dispatch(fetchNotificationCount());
      dispatch(fetchCommentCount());
      dispatch(fetchNewCaseNotificationCount());
    });

    // Cleanup when component unmounts
    return () => unsubscribe();
  }, [dispatch]);

  useEffect(() => {
    getRequestToken();
  }, [userChanged]);
  useEffect(() => {
    if (user?.user) {
      dispatch(fetchNotificationCount());
      dispatch(fetchCommentCount());
      dispatch(fetchNewCaseNotificationCount());
      dispatch(fetchUserAssignedCases());
      dispatch(fetchRpaRunningHospitals());
      getUserAssignedStages();
    }
  }, [dispatch, userChanged]);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return (
    <div className="main_container">
      <Routes>
        <Route path="/">
          <Route index element={<LandingPage />} />
        </Route>
        <Route path="/login-signup" element={<PublicRoute />}>
          <Route index element={<Homepage />} />
        </Route>
        <Route path="/under-review" element={<PrivateRoute1 />}>
          <Route index element={<UnderReview />}></Route>
        </Route>
        <Route path="/dashboard" element={<PrivateRoute1 />}>
          {currentRole?.role?.roleName === "Hospital" ? (
            <Route index element={<Hospitaldashboard />} />
          ) : (
            <Route index element={<DashBoard />} />
          )}
          <Route path="/dashboard/addhospital" element={<AddHospital />} />
          <Route path="/dashboard/hospitallist" element={<Hospitallist />} />
          <Route
            path="/dashboard/approvehospital"
            element={<ApproveHospital />}
          />
          <Route
            path="/dashboard/hospital-speciality-mapping"
            element={<HospitalSpecialityMapping />}
          />
        </Route>
        <Route path="/dashboard/ActiveCases" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/ActiveCases"
            Component={ActiveCasesDashboardV2}
          />
        </Route>
        <Route path="/dashboard/ActiveCasesBeta" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/ActiveCasesBeta"
            Component={ActiveCasesDashboardBeta}
          />
        </Route>
        <Route path="/dashboard/claimed-cases" element={<PrivateRoute1 />}>
          <Route path="/dashboard/claimed-cases" Component={ClaimCases} />
        </Route>

        <Route path="/dashboard/my-assigned-cases" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/my-assigned-cases"
            Component={MyAssignedCases}
          />
        </Route>
        <Route path="/dashboard/requirement-report" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/requirement-report"
            element={<RequirementReport />}
          />
        </Route>
        <Route
          path="/dashboard/doctor-performance-report"
          element={<PrivateRoute1 />}
        >
          <Route
            path="/dashboard/doctor-performance-report"
            element={<DoctorPerformanceReport />}
          />
        </Route>
        <Route
          path="/dashboard/doctor-case-stage-update"
          element={<PrivateRoute1 />}
        >
          <Route
            path="/dashboard/doctor-case-stage-update"
            element={
              <div
                className="min-h-screen w-full flex-1 min-w-0 bg-[#f5f5f5] p-4 md:p-5 lg:p-6 xl:p-6 2xl:p-8 font-lufga overflow-x-hidden box-border"
                style={{ marginTop: 100 }}
              >
                <DoctorCaseStageUpdate />
              </div>
            }
          />
        </Route>
        <Route
          path="/dashboard/dut-performance-report"
          element={<PrivateRoute1 />}
        >
          <Route
            path="/dashboard/dut-performance-report"
            element={<DutPerformanceReport />}
          />
        </Route>
        <Route
          path="/dashboard/dut-case-stage-update"
          element={<PrivateRoute1 />}
        >
          <Route
            path="/dashboard/dut-case-stage-update"
            element={
              <div
                className="min-h-screen w-full flex-1 min-w-0 bg-[#f5f5f5] p-4 md:p-5 lg:p-6 xl:p-6 2xl:p-8 font-lufga overflow-x-hidden box-border"
                style={{ marginTop: 100 }}
              >
                <DutCaseStageUpdate />
              </div>
            }
          />
        </Route>
        <Route
          path="/dashboard/internal-user-management"
          element={<PrivateRoute1 />}
        >
          <Route
            path="/dashboard/internal-user-management"
            Component={InternalUserManagement}
          />
          <Route
            path="/dashboard/internal-user-management"
            Component={InternalUserManagement}
          />
        </Route>
        <Route path="/dashboard/internal-user-list" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/internal-user-list"
            Component={InternalUsers}
          />
        </Route>
        {/* <Route path="/dashboard/ActiveCasesV2" element={<PrivateRoute1 />}>
  <Route path="/dashboard/ActiveCasesV2" element={<ActiveCasesDashboardV2 />} />
</Route> */}

        <Route path="/dashboard/manage-rpa" element={<PrivateRoute1 />}>
          <Route path="/dashboard/manage-rpa" element={<ManageRpa />} />
        </Route>

        <Route path="/dashboard/manage-rpa-logs" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/manage-rpa-logs"
            element={<ManageRpaLogs />}
          />
        </Route>
        <Route path="/dashboard/dut-flow" element={<PrivateRoute1 />}>
          <Route path="/dashboard/dut-flow" element={<NewDutAccordion />} />
        </Route>
        <Route path="/dashboard/dut-chat-flow" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/dut-chat-flow"
            element={<ClaimInsightsScreen />}
          />
        </Route>
        <Route path="/dashboard/dut-work-space" element={<PrivateRoute1 />}>
          <Route path="/dashboard/dut-work-space" element={<DutWorkspace />} />
        </Route>
        <Route path="/dashboard/rpa-error-logs" element={<PrivateRoute1 />}>
          <Route index element={<RpaErrorLogs />} />
        </Route>
        <Route
          path="/dashboard/rpa-query-request-logs"
          element={<PrivateRoute1 />}
        >
          <Route index element={<RpaQueryRequestLog />} />
        </Route>
        <Route path="/dashboard/tms-login-details" element={<PrivateRoute1 />}>
          <Route index element={<TmsLoginDetails />} />
        </Route>
        <Route path="/dashboard/manage-query" element={<PrivateRoute1 />}>
          <Route path="/dashboard/manage-query" element={<Managequery />} />
        </Route>

        <Route
          path="/dashboard/manage-applicationid"
          element={<PrivateRoute1 />}
        >
          <Route
            path="/dashboard/manage-applicationid"
            element={<ManageApplication />}
          />
        </Route>
        <Route path="/dashboard/inter-case" element={<PrivateRoute1 />}>
          <Route path="/dashboard/inter-case" element={<InterCase />} />
        </Route>

        <Route path="/Dashboard/ManageCases" element={<PrivateRoute1 />}>
          <Route path="/Dashboard/ManageCases" Component={InitiateAdmission} />
        </Route>
        <Route
          path="/Dashboard/processed-query-cases"
          element={<PrivateRoute1 />}
        >
          <Route
            path="/Dashboard/processed-query-cases"
            Component={ProcessedQueryCases}
          />
        </Route>
        <Route path="/addcases" element={<PrivateRoute1 />}>
          <Route index element={<AddCasesDashboard />} />
        </Route>
        <Route path="/Subscriptionplan" element={<PrivateRoute1 />}>
          <Route index element={<Subscriptionplan />} />
        </Route>
        <Route path="/forgotpassword" element={<PublicRoute />}>
          <Route index element={<Forgotpassword />} />
        </Route>
        <Route path="/dashboard/adddoctor" element={<PrivateRoute1 />}>
          <Route index element={<AddDoctor />} />
        </Route>
        <Route
          path="/dashboard/manage-procedure-page"
          element={<PrivateRoute1 />}
        >
          <Route index element={<ManageProcedurePage />} />
        </Route>
        <Route
          path="/dashboard/default-doc-mapping"
          element={<PrivateRoute1 />}
        >
          <Route index element={<DefaultDocumentMappingPage />} />
        </Route>
        <Route
          path="/dashboard/procedure-document-mapping"
          element={<PrivateRoute1 />}
        >
          <Route index element={<ProcedureDocumentMapping />} />
        </Route>
        <Route
          path="/dashboard/procedure-mapping-page"
          element={<PrivateRoute1 />}
        >
          <Route index element={<ProcedureMappingPage />} />
        </Route>

        <Route
          path="/dashboard/procedure-cost-mapping"
          element={<PrivateRoute1 />}
        >
          <Route index element={<ProcedureCostMapping />} />
        </Route>
        <Route
          path="/dashboard/procedure-cost-mapping-edited"
          element={<PrivateRoute1 />}
        >
          <Route index element={<ProcedureCostMappingEdited />} />
        </Route>
        <Route
          path="/dashboard/procedure-cost-mapping"
          element={<PrivateRoute1 />}
        >
          <Route index element={<ProcedureCostMapping />} />
        </Route>
        <Route
          path="/dashboard/procedure-cost-mapping"
          element={<PrivateRoute1 />}
        >
          <Route index element={<ProcedureCostMapping />} />
        </Route>
        <Route
          path="/dashboard/doctor-forwarded-query-page"
          element={<PrivateRoute1 />}
        >
          <Route index element={<DutPage />} />
        </Route>
        <Route path="/dashboard/EditDocuments" element={<PrivateRoute1 />}>
          <Route index element={<EditDocuments />} />
        </Route>
        <Route path="/inactivestaff/homepage" element={<PublicRoute />}>
          <Route index element={<Homepage />} />
        </Route>
        <Route path="/teammemberdashboard" element={<PublicRoute />}>
          <Route index element={<Teanmemberdashboard />} />
        </Route>
        <Route path="/hospitaldashboard" element={<PrivateRoute1 />}>
          <Route index element={<Hospitaldashboard />} />
        </Route>
        <Route path="/dashboard/mapdocuments" element={<PrivateRoute1 />}>
          <Route index element={<MapDocumentCaseList />} />
        </Route>
        <Route path="/dashboard/manageprocedure" element={<PrivateRoute1 />}>
          <Route index element={<ManageProcedure />} />
        </Route>
        <Route path="/dashboard/manage-documents" element={<PrivateRoute1 />}>
          <Route index element={<ManageDocuments />} />
        </Route>
        <Route path="/dashboard/manage-speciality" element={<PrivateRoute1 />}>
          <Route index element={<ManageSpeciality />} />
        </Route>
        <Route path="/dashboard/manage-scheme" element={<PrivateRoute1 />}>
          <Route index element={<ManageScheme />} />
        </Route>
        <Route
          path="/dashboard/managedocx-typemapping"
          element={<PrivateRoute1 />}
        >
          <Route index element={<ManageDocxTypeMapping />} />
        </Route>
        <Route
          path="/dashboard/manage-procedure-scheme-mapping"
          element={<PrivateRoute1 />}
        >
          <Route index element={<ManageProcedureSchemeMapping />} />
        </Route>
        <Route
          path="/dashboard/default-procedure-list"
          element={<PrivateRoute1 />}
        >
          <Route index element={<DefaultProcedureList />} />
        </Route>

        <Route path="/dashboard/subscription" element={<PrivateRoute1 />}>
          <Route index element={<SubscriptionBox />} />
        </Route>
        <Route path="/addstaff" element={<PrivateRoute1 />}>
          <Route index element={<AddSubadmin />} />
        </Route>
        <Route path="/dashboard/updated-features" element={<PrivateRoute1 />}>
          <Route index element={<UpdatedFeatures />} />
        </Route>
        <Route
          path="/dashboard/user-insights-count"
          element={<PrivateRoute1 />}
        >
          <Route index element={<UserInsightsCount />} />
        </Route>

        <Route path="/dashboard/editsubadmin" element={<PrivateRoute1 />}>
          <Route index element={<EditSubadmin />} />
        </Route>
        <Route path="/dashboard/all-case-recording" element={<PrivateRoute1 />}>
          <Route index element={<AllCaseRecording />} />
        </Route>
        <Route path="/stafflist" element={<PrivateRoute1 />}>
          <Route index element={<Subadminlist />} />
        </Route>
        <Route path="/dashboard/upload-documents" element={<PrivateRoute1 />}>
          <Route index element={<DirectUploadDocUi />} />
        </Route>
        <Route path="/report/daily-case-tracking" element={<PrivateRoute1 />}>
          <Route index element={<Report />} />
        </Route>
        <Route
          path="/report/daily-case-tracking-doc-type-wise"
          element={<PrivateRoute1 />}
        >
          <Route index element={<CcReportDocumentTypeWise />} />
        </Route>
        <Route path="/rpa-report" element={<PrivateRoute1 />}>
          <Route index element={<RpaReport />} />
        </Route>
        <Route path="/rpa-case-wise-report" element={<PrivateRoute1 />}>
          <Route index element={<RpaCaseWiseReport />} />
        </Route>
        <Route path="/hsa-report-for-cc" element={<PrivateRoute1 />}>
          <Route index element={<HsaReportForCC />} />
        </Route>
        <Route path="/Dashboard/EditCases" element={<PrivateRoute1 />}>
          <Route index element={<EditCasesDashboard />} />
        </Route>
        <Route path="/Dashboard/diagnosis-search" element={<PrivateRoute1 />}>
          <Route index element={<ECTDiagnosisSearch />} />
        </Route>
        <Route path="/dashboard/manualNotification" element={<PrivateRoute1 />}>
          <Route index element={<ManualNotification />} />
        </Route>
        <Route path="/dashboard/download-ref-doc" element={<PrivateRoute1 />}>
          <Route index element={<ReferenceDocDownload />} />
        </Route>
        <Route
          path="/dashboard/icd10-diagnosis-search"
          element={<PrivateRoute1 />}
        >
          <Route index element={<ICD10DiagnosisSearch />} />
        </Route>

        <Route
          path="/Dashboard/notificationsStructure"
          element={<PrivateRoute1 />}
        >
          <Route index element={<NotificationsStructure />} />
        </Route>
        <Route path="/Dashboard/digital-medco-otp" element={<PrivateRoute1 />}>
          <Route index element={<TmsOtpList />} />
        </Route>
        <Route
          path="/Dashboard/digital-medco-otp-logs"
          element={<PrivateRoute1 />}
        >
          <Route index element={<TmsOtpLogsList />} />
        </Route>
        <Route path="/Dashboard/user-insights" element={<PrivateRoute1 />}>
          <Route index element={<GetTmsUserVersionsList />} />
        </Route>
        <Route path="/dashboard/document-comment" element={<PrivateRoute1 />}>
          <Route index element={<CcDocumentComentWithKey />} />
        </Route>
        <Route path="/dashboard/manage-invoice" element={<PrivateRoute1 />}>
          <Route index element={<ManageInvoice />} />
          <Route path="create-invoice" element={<CreateInvoice />} />
        </Route>
        <Route path="/dashboard/survey-details" element={<PrivateRoute1 />}>
          <Route index element={<SurveyDetails />} />
        </Route>
        <Route path="/ai-form" element={<PublicRoute />}>
          <Route index element={<AiForm />} />
        </Route>
        <Route path="/dashboard/cc-hospital-report" element={<PrivateRoute1 />}>
          <Route index element={<CcMonthlyCaseReport />} />
        </Route>
        <Route path="/dashboard/cc-revenue-report" element={<PrivateRoute1 />}>
          <Route index element={<CcCreditReport />} />
        </Route>
        <Route path="/dashboard/ai-configurations" element={<PrivateRoute1 />}>
          <Route index element={<AiConfigurations />} />
        </Route>
        <Route
          path="/dashboard/manage-survey-questions"
          element={<PrivateRoute1 />}
        >
          <Route index element={<ManageSurveyQuestions />} />
        </Route>
        <Route
          path="/dashboard/survey-questions-report"
          element={<PrivateRoute1 />}
        >
          <Route index element={<SurveyQuestionsReport />} />
        </Route>
        <Route path="/dashboard/case-stages-info" element={<PrivateRoute1 />}>
          <Route index element={<AllCaseStagesInfo />} />
        </Route>
        <Route
          path="/dashboard/case-stages-time-color-info"
          element={<PrivateRoute1 />}
        >
          <Route index element={<CaseStageTimeColorIfo />} />
        </Route>
        <Route path="/Dashboard/ActiveCases/v2" element={<PublicRoute1 />}>
          <Route index element={<ActiveCasesDashboardV2 />} />
        </Route>
        <Route path="/Dashboard/EditCases/v2" element={<PublicRoute1 />}>
          <Route index element={<EditCasesDashboard />} />
        </Route>
        {/* Survey */}
        <Route path="/survey" element={<PublicRoute />}>
          <Route path="/survey" element={<SurveyForm />} />
        </Route>
        {/* <Route path="/account-form" element={<PublicRoute />}>
          <Route index element={<DeactivateAccountForm />} />
        </Route> */}
        <Route path="/account-form">
          <Route index element={<DeactivateAccountForm />} />
        </Route>

        {/* Hospital and HSA persona routes */}
        <Route path="/dashboard/case-status" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/case-status"
            element={<CaseStatus key={location.pathname} />}
          />
          <Route
            path="/dashboard/case-status/document-comments"
            element={<DocumentComments />}
          />
          <Route
            path="/dashboard/case-status/:id"
            element={<CaseDetailsHospitalPersona />}
          />
        </Route>
        <Route path="/dashboard/dialysis" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/dialysis"
            element={<CaseStatus key={location.pathname} />}
          />

          <Route
            path="/dashboard/dialysis/:id"
            element={<CaseDetailsHospitalPersona />}
          />
        </Route>
        <Route path="/dashboard/notifications" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/notifications"
            element={<NotificationHospitalPersona />}
          />
        </Route>
        <Route
          path="/dashboard/comment-notifications"
          element={<PrivateRoute1 />}
        >
          <Route
            path="/dashboard/comment-notifications"
            element={<CommentNotificationHospitalPersona />}
          />
        </Route>
        <Route
          path="/dashboard/hsa-monthly-case-report"
          element={<PrivateRoute1 />}
        >
          <Route
            path="/dashboard/hsa-monthly-case-report"
            element={<HsaMonthlyCaseReport />}
          />
        </Route>
        <Route path="/dashboard/revenue-credited" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/revenue-credited"
            element={<RevenueReport />}
          />
        </Route>
      </Routes>
      <Routes>
        <Route path="/dashboard/sub-admin" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/sub-admin"
            element={<HospitalPersonaSubAdmin />}
          />
        </Route>
      </Routes>
      <Routes>
        <Route path="/dashboard/report" element={<PrivateRoute1 />}>
          <Route path="/dashboard/report" element={<HospitalCaseReport />} />
        </Route>
      </Routes>

      {/* <Routes>
          <Route
            path="/dashboard/case-status/document-comments"
            element={<PrivateRoute1 />}
          >
            <Route
              path="/dashboard/case-status/document-comments"
              element={<DocumentComments />}
            />
          </Route>
        </Routes> */}

      <Routes>
        <Route path="/dashboard/doctorlist" element={<PrivateRoute1 />}>
          <Route path="/dashboard/doctorlist" element={<DoctorList />} />
        </Route>
      </Routes>
      <Routes>
        <Route path="/dashboard/dm-report" element={<PrivateRoute1 />}>
          <Route path="/dashboard/dm-report" element={<DmLogReport />} />
        </Route>
      </Routes>

      <Routes>
        <Route path="/dashboard/imageuploadtest" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/imageuploadtest"
            element={<ImageUploadTestPage />}
          />
        </Route>
      </Routes>
      <Routes>
        <Route path="/dashboard/improvementform" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/improvementform"
            element={<ImprovementFeedbackForm />}
          />
        </Route>
      </Routes>
      <Routes>
        <Route path="/dashboard/betahospitallist" element={<PrivateRoute1 />}>
          <Route
            path="/dashboard/betahospitallist"
            element={<HospitalListBeta />}
          />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
